import { TFunction } from 'i18next';

import { PaymentTerms } from '../types';

export interface PaymentTermsOption {
  value: PaymentTerms;
  label: string;
}

/**
 * Returns available payment terms options for client billing.
 * This is a static list that doesn't come from the backend.
 *
 * @param t - Translation function from i18next
 * @returns Array of payment term options with localized labels
 */
export const getPaymentTermsOptions = (t: TFunction): PaymentTermsOption[] => {
  return [
    { value: PaymentTerms.Net7, label: t('authenticated.clients:paymentTerms.net7') },
    { value: PaymentTerms.Net15, label: t('authenticated.clients:paymentTerms.net15') },
    { value: PaymentTerms.Net30, label: t('authenticated.clients:paymentTerms.net30') },
    { value: PaymentTerms.Net45, label: t('authenticated.clients:paymentTerms.net45') },
    { value: PaymentTerms.Net60, label: t('authenticated.clients:paymentTerms.net60') },
    { value: PaymentTerms.Net90, label: t('authenticated.clients:paymentTerms.net90') },
    {
      value: PaymentTerms.EndOfMonth,
      label: t('authenticated.clients:paymentTerms.end_of_month'),
    },
    {
      value: PaymentTerms.CashInAdvance,
      label: t('authenticated.clients:paymentTerms.cash_in_advance'),
    },
    {
      value: PaymentTerms.CashOnDelivery,
      label: t('authenticated.clients:paymentTerms.cash_on_delivery'),
    },
    {
      value: PaymentTerms.CashWithOrder,
      label: t('authenticated.clients:paymentTerms.cash_with_order'),
    },
  ];
};
